import { atomWithStorage } from 'jotai/utils';

// ダークモード設定を localStorage に永続化する atom
// 'app-theme-dark': true = ダークモード, false = ライトモード（デフォルト）
export const darkModeAtom = atomWithStorage<boolean>('app-theme-dark', false);
